export const DATE_FORMAT_YMD_DOTTED = 'YYYY.MM.DD';
export const DATE_FORMAT_ISO_NO_MS = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_FORMAT_YMD_SLASHED = 'YYYY/MM/DD';
export const DATE_FORMAT_YMD_HYPHEN = 'YYYY-MM-DD';
export const DATE_FORMAT_YM_DOTTED = 'YYYY.MM';
export const DATE_FORMAT_YMD_HM_DOTTED = 'YYYY-MM-DD HH:mm';
